import React from "react";
import "./style.css";

const ContentButton = ({label, href}) => {
  return (
    <a className="content-button" href={href} draggable={false}>{label}</a>
  );
};

export default ContentButton;